// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rz-0";